import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainSelect", "assistantsSelect", "forLetterCheckbox", "letterContainer", "letterHint"]
  static values = {
    specialIds: Array
  }

  connect() {
    setTimeout(() => {
      this.syncSelects()
      this.checkSpecialUsers()
    }, 10)
  }

  mainChanged(event) {
    this.syncSelects()
    const isEventFromCheckbox = event && event.target === this.forLetterCheckboxTarget

    this.checkSpecialUsers(isEventFromCheckbox)
  }

  checkSpecialUsers(skipScroll = false) {
    if (!this.hasMainSelectTarget || !this.hasForLetterCheckboxTarget) return

    const mainTomSelect = this.mainSelectTarget.tomselect
    const selectedMainIds = mainTomSelect
      ? mainTomSelect.items.map(Number)
      : Array.from(this.mainSelectTarget.selectedOptions).map(o => Number(o.value))

    const hasSpecialUser = selectedMainIds.some(id => this.specialIdsValue.includes(id))
    const isAlreadyChecked = this.forLetterCheckboxTarget.checked

    if (hasSpecialUser && !isAlreadyChecked) {
      this.highlightCheckbox(skipScroll)
    } else {
      this.resetHighlight()
    }
  }

  highlightCheckbox(skipScroll = false) {
    if (!this.hasLetterContainerTarget) return

    this.letterContainerTarget.classList.add("bg-amber-50", "border", "border-amber-200", "scale-[1.01]", "shadow-sm")
    const label = this.letterContainerTarget.querySelector("label")
    if (label) label.classList.add("font-semibold", "text-amber-900")

    if (this.hasLetterHintTarget) {
      this.letterHintTarget.classList.remove("hidden")
    }

    if (!skipScroll) {
      this.letterContainerTarget.scrollIntoView({
        behavior: "smooth",
        block: "center"
      })
    }
  }


  resetHighlight() {
    if (!this.hasLetterContainerTarget) return
    this.letterContainerTarget.classList.remove("bg-amber-50", "border", "border-amber-200", "scale-[1.01]", "shadow-sm")
    const label = this.letterContainerTarget.querySelector("label")
    if (label) label.classList.remove("font-semibold", "text-amber-900")

    if (this.hasLetterHintTarget) {
      this.letterHintTarget.classList.add("hidden")
    }
  }

  syncSelects() {
    const mainSelect = this.mainSelectTarget
    const assistantsSelect = this.assistantsSelectTarget

    const mainTomSelect = mainSelect.tomselect
    const assistantTomSelect = assistantsSelect.tomselect

    if (!assistantTomSelect) return

    const selectedMainIds = mainTomSelect
      ? mainTomSelect.items.map(String)
      : Array.from(mainSelect.selectedOptions).map(o => String(o.value))

    selectedMainIds.forEach((id) => {
      assistantTomSelect.removeItem(id)
    })

    Object.keys(assistantTomSelect.options).forEach((id) => {
      const optionId = String(id)
      const isMain = selectedMainIds.includes(optionId)

      assistantTomSelect.options[id].disabled = isMain

      const nativeOption = assistantsSelect.querySelector(`option[value="${id}"]`)
      if (nativeOption) {
        nativeOption.disabled = isMain
      }

      const dropdownItem = assistantTomSelect.dropdown_content.querySelector(`[data-value="${id}"]`)
      if (dropdownItem) {
        if (isMain) {
          dropdownItem.classList.add('disabled')
          dropdownItem.setAttribute('aria-disabled', 'true')
          dropdownItem.style.pointerEvents = 'none'
          dropdownItem.style.opacity = '0.5'
        } else {
          dropdownItem.classList.remove('disabled')
          dropdownItem.removeAttribute('aria-disabled')
          dropdownItem.style.pointerEvents = ''
          dropdownItem.style.opacity = ''
        }
      }
    })

    assistantTomSelect.clearCache()
    assistantTomSelect.refreshOptions(false)
  }
}
